import React from 'react';
import { Helmet } from 'react-helmet';

function StructuredData() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "GuardiansMoves",
    "alternateName": "GuardiansMoves Security & Transport Berlin", 
    "image": "https://guardiansmoves.de/logo512.png",
    "url": "https://guardiansmoves.de",
    "telephone": "+4915563547378",
    "email": "info@guardiansmoves.de",
    "description": "GuardiansMoves ist Ihr zuverlässiger Partner für professionelle Dienstleistungen im Bereich Sicherheit (Security), Personenbeförderung und Reinigung in Berlin. Wir bieten Sicherheitsdienste, Taxi- und Mietwagenservice sowie professionelle Reinigungsleistungen.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Müllerstr. 3",
      "addressLocality": "Berlin",
      "postalCode": "13353",
      "addressCountry": "DE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "52.5400",
      "longitude": "13.3700"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "14:00"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/guardiansmoves"
    ],
    "keywords": "Sicherheit, Security, Sicherheitsdienst Berlin, Taxi Berlin, Personenbeförderung, Reinigungsservice, GuardiansMoves, Sicherheitsfirma", 
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Dienstleistungen",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Sicherheitsdienste Berlin (Security Services)",
            "description": "Professionelle Sicherheitsdienste und Security-Lösungen für Veranstaltungen und Objekte in Berlin. Als Sicherheitsfirma bieten wir zuverlässigen Schutz."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Taxi & Mietwagenservice Berlin",
            "description": "Zuverlässiger Taxi und Mietwagenservice in Berlin und Brandenburg. Professionelle Personenbeförderung für alle Anlässe."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Reinigungsdienste Berlin",
            "description": "Professionelle Reinigungsdienste für private und gewerbliche Immobilien in Berlin."
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}

export default StructuredData;